import React, { useRef, useEffect } from "react";
import videoFile from "../../asset/videoFile.mp4";
import "./video.css";

const Video = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      video.currentTime = 0.9; // Start at 0.5 seconds
      video.muted = true; // Mute it to prevent sound issues
      video
        .play()
        .then(() => {
          video.pause(); // Play briefly to update the preview frame
          video.muted = false; // Unmute for normal playback
        })
        .catch((error) => console.log("Autoplay prevented:", error));
    }
  }, []);
  return (
    <>
      <div className="video-container">
        <video ref={videoRef} controls playsInline>
          <source src={videoFile} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </>
  );
};

export default Video;
